/**
 * TanStack Query hooks for `igaming-crypto-payment-tracking-usdt-btc-eth-on-player-pipeline`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys,
	type CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineBody,
	type ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineResponse,
	type IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRow,
} from "./api";

export function useIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineList(): UseQueryResult<ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineResponse, Error> {
	return useQuery({
		queryKey: igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineCreate(): UseMutationResult<IgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineRow, Error, CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys.all });
		},
	});
}

export function useIgamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCryptoPaymentTrackingUsdtBtcEthOnPlayerPipelineQueryKeys.all });
		},
	});
}
